module.exports = __webpack_public_path__ + "08de2503d97c3c6ced68bfa06bd6f239.svg";